var _style, _path, _path2, _path3, _line, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,19.9v2.8c-4.9,0.9-8.6,3.8-9,7.4H28c-0.4-3.6-4.1-6.5-9-7.4V20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,23.4c-0.8,1.3-3,2.2-5.7,2.2c-2.6,0-4.9-0.9-5.7-2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,17H10.3C8.5,17,7,15.5,7,13.7V9.3C7,7.5,8.5,6,10.3,6h11.5C23.5,6,25,7.5,25,9.3v4.5 C25,15.5,23.5,17,21.7,17z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 10,
    x2: 19,
    y2: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,17c-1.5,2.5-3.7,4-5.5,4c-1.8,0-4-1.5-5.5-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,6.1C10.6,3.5,12.7,2,16,2c3.3,0,5.4,1.5,6.6,4.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrUser);
export default __webpack_public_path__ + "static/media/vrUser.a8d8d5799d058bcfc02e43a54a600149.svg";
export { ForwardRef as ReactComponent };